




























import {Component, Vue} from 'vue-property-decorator';
import Header from '@/app/components/Header.vue';
import Footer from '@/app/components/Footer.vue';

@Component({
    components: {Footer, Header},
})
export default class About extends Vue {

    contributers = [
        {
            name: 'Philipp Steiner',
            avatar: 'https://avatars.githubusercontent.com/u/9675234?s=128',
            link: 'https://github.com/jordilaforge',
        }, {
            name: 'Gery Hirschfeld',
            avatar: 'https://avatars.githubusercontent.com/u/6384499?s=128',
            link: 'https://github.com/hirsch88',
        }, {
            name: 'Markus Tiede',
            avatar: 'https://avatars.githubusercontent.com/u/1764012?s=128',
            link: 'https://github.com/MarkusTiede',
        }, {
            name: 'Rudolf Biczok',
            avatar: 'https://avatars.githubusercontent.com/u/538973?s=128',
            link: 'https://github.com/RCBiczok',
        }, {
            name: 'Yannick Holzenkamp',
            avatar: 'https://avatars.githubusercontent.com/u/9351023?s=128',
            link: 'https://github.com/yannickholzenkamp',
        },


    ];

}
